export * from './helps/helps.component';
export * from './home/home.component';
export * from './legals/legals.component';
export * from './about/about.component';
export * from './settings-list/settings-list.component';
